/**
 * PickInfoIcon – info (i) for pick type explanations on Match Details.
 * Thin wrapper around shared InfoTooltip with pick-specific accessibility label.
 */

import React from 'react';
import { InfoTooltip } from '../../../src/shared/components/InfoTooltip';

export interface PickInfoIconProps {
  /** Short explanation of the pick (from MARKET_PICK_DESCRIPTIONS). */
  description: string;
  /** Smaller icon when true (e.g. compact predicting step). */
  compact?: boolean;
}

export const PickInfoIcon: React.FC<PickInfoIconProps> = ({
  description,
  compact = false,
}) => (
  <InfoTooltip
    content={description}
    compact={compact}
    accessibilityLabel="What is this pick?"
  />
);
